import moment from "moment";
import {flatten, get, memoize} from "lodash";

const settlementList = (timeNow, CID) => [
    {
        DtaStartTime: +moment.utc(timeNow).startOf("day").subtract(14, "days"),
        DtaEndTime: +moment.utc(timeNow).endOf("day"),
        PlcmntID: CID,
        Age: 160

    }
]

export const fakeGetSettlementList = memoize((state, props) => {
    console.log("fakeGetSettlementList", state, props)
    const chamberIds = [];
    const buildingsList = get(state, "farms.buildings", []);
    buildingsList.forEach(b => {
        get(b, "Sectors", []).forEach(s => {
            get(s, "Chambers", []).forEach(c => {
                chamberIds.push(c.CID);
            })
        })
    })
    const result = flatten(chamberIds.map(cid => settlementList(+new Date(), cid)));
    console.log(result);
    return result;
}, (state => get(state, "farms.buildings.length", 0)))
